import React from 'react';
import RaisedButton from 'material-ui/RaisedButton';
import {FormattedMessage} from 'react-intl';
import EventsCalendarContainer from './eventsCalendar/eventsCalendar.container';
import EventsTableContainer from './eventsTable/eventsTable.container';
import './myEvents.css';

class Events extends React.Component {
   constructor(props) {
      super(props);
      this.state = {
         showCalendar:false,
         showActive:true
      };
   }

   togglePageViewState() {
      this.setState({
         showCalendar: !this.state.showCalendar
      });
   }

   toggleEventsPeriodState() {
      this.setState({
         showActive: !this.state.showActive
      });
   }

   renderCalendar() {
      return this.state.showCalendar ? <EventsCalendarContainer/> :  null;
   }

   renderTable() {
      return this.state.showCalendar ? null : <EventsTableContainer showActive={this.state.showActive}/>;
   }

   renderEventsPeriodButton() {
      if (!this.state.showCalendar) {
         return (<RaisedButton className="eventsPageTableViewButton" primary={true}
                               label={<FormattedMessage id={this.state.showActive ? "events.viewActive" : "events.viewPast"}/>}
                               onClick={this.toggleEventsPeriodState.bind(this)}/>);
      }
      return null;
   }

   render() {
      return (
         <div>
            <RaisedButton className="eventsPageViewAsButton" primary={true}
                          label={<FormattedMessage id={this.state.showCalendar ? "events.viewAsTable" : "events.viewAsCalendar"}/>}
                           onClick={this.togglePageViewState.bind(this)}/>
            {this.renderEventsPeriodButton()}
            <div className="eventsPageContent">
               {this.renderCalendar()}
               {this.renderTable()}
            </div>
         </div>
      );
   }
}

export default Events;



// WEBPACK FOOTER //
// ./src/pages/myEvents/myEventsPage.js